import Vue from 'vue'
import App from './App.vue'

import { BootstrapVue } from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.js';
import i18n from '@/plugins/i18n';
import FlagIcon from 'vue-flag-icon';
import VueRouter from 'vue-router';
import VueResource from 'vue-resource';
import VueScrollTo from 'vue-scrollto';
require('vue2-animate/dist/vue2-animate.min.css');

import  routes  from "./routes";
import store from "./store/store";

Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(FlagIcon);
Vue.use(VueResource);
Vue.use(VueRouter);

Vue.use(VueScrollTo,{
  container: "body",
  duration: 500,
  easing: "ease-in-out",
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
});

const router = new VueRouter({
  routes,
  base: process.env.BASE_URL,
  mode: "history",
  scrollBehavior (to, from, savedPosition) {
    if(savedPosition){

      return savedPosition;

    }
  }
});


router.beforeEach ((to, from, next) => {
  let language = to.params.lang;
  
  if(!language) {
    language = "en";
  }
  i18n.locale = language; 
  store.dispatch('changeLocale', language)
  next();
});

new Vue({
  i18n,
  router,
  store,
  render: h => h(App),
}).$mount('#app')
